document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') {
        return;
    }

    const wraps     = document.querySelectorAll('.custom-slider');
    const MOBILE_MQ = window.matchMedia('(max-width: 767px)');

    if (!wraps.length) {
        return;
    }

    const isMobile = () => MOBILE_MQ.matches;

    const getSliderConfig = (mobile, initialSlide = 0) => {

        const config = {
            initialSlide,
            direction     : mobile ? 'horizontal': 'vertical',
            effect        : mobile ? 'slide'     : 'cards',
            grabCursor    : mobile,
            allowTouchMove: mobile,
            simulateTouch : mobile,
            slidesPerView : 1,
            spaceBetween  : mobile ? 10          : 0,
            loop          : false,
        };

        if (!mobile) {
            config.cardsEffect = {
                slideShadows  : false,
                rotate        : false,
                perSlideRotate: 0,
                perSlideOffset: 12,
            };
        }

        return config;
    };

    const getSlideTitle = (slide) => {
        if (!slide) {
            return '';
        }

        if (slide.dataset.slideTitle) {
            return slide.dataset.slideTitle;
        }

        const img = slide.querySelector('img');

        return img?.getAttribute('title') || '';
    };

    const initCounter = (swiper, wrap) => {
        const currentSlideEl = wrap.querySelector('.current-slide');
        const totalSlidesEl  = wrap.querySelector('.total-slides');

        if (totalSlidesEl) {
            totalSlidesEl.textContent = String(swiper.slides.length).padStart(2, '0');
        }

        if (!currentSlideEl) {
            return;
        }

        const updateCounter = () => {
            currentSlideEl.textContent = String(swiper.activeIndex + 1).padStart(2, '0');
        };

        updateCounter();
        swiper.on('slideChange', updateCounter);
    };

    const initNavigation = (swiper, wrap) => {
        const nextButtons = wrap.querySelectorAll('.slider-btn.next');
        const prevButtons = wrap.querySelectorAll('.slider-btn.prev');

        const onNext = () => swiper.slideNext();
        const onPrev = () => swiper.slidePrev();

        nextButtons.forEach((btn) => btn.addEventListener('click', onNext));
        prevButtons.forEach((btn) => btn.addEventListener('click', onPrev));

        const updateState = () => {
            const atStart = swiper.isBeginning;
            const atEnd   = swiper.isEnd;

            prevButtons.forEach((btn) => {
                btn.disabled = atStart;
                btn.classList.toggle('swiper-button-disabled', atStart);
            });
            nextButtons.forEach((btn) => {
                btn.disabled = atEnd;
                btn.classList.toggle('swiper-button-disabled', atEnd);
            });
        };

        updateState();
        swiper.on('slideChange', updateState);
        swiper.on('destroy', () => {
            nextButtons.forEach((btn) => btn.removeEventListener('click', onNext));
            prevButtons.forEach((btn) => btn.removeEventListener('click', onPrev));
        });
    };

    const initTitle = (swiper, wrap) => {
        const titleEl = wrap.querySelector('.custom-slider__title');

        if (!titleEl) {
            return;
        }

        const updateTitle = () => {
            titleEl.textContent = getSlideTitle(swiper.slides[swiper.activeIndex]);
        };

        updateTitle();
        swiper.on('slideChange', updateTitle);
    };

    const createSwiper = (sliderEl, wrap, initialSlide = 0) => {
        const mobile = isMobile();

        sliderEl.classList.toggle('custom-slider__slider--horizontal', mobile);
        sliderEl.classList.toggle('custom-slider__slider--vertical', !mobile);

        const swiper = new Swiper(sliderEl, getSliderConfig(mobile, initialSlide));

        initCounter(swiper, wrap);
        initNavigation(swiper, wrap);
        initTitle(swiper, wrap);

        return {
            swiper,
            wrap,
            mode: mobile ? 'mobile': 'desktop',
        };
    };

    const sliderState = new Map();

    wraps.forEach((wrap) => {
        if (wrap.closest('.acf-block-preview')) {
            return;
        }

        const sliderEl = wrap.querySelector('.custom-slider__slider');

        if (!sliderEl) {
            return;
        }

        sliderState.set(sliderEl, createSwiper(sliderEl, wrap));
    });

    MOBILE_MQ.addEventListener('change', () => {
        const nextMode = isMobile() ? 'mobile' : 'desktop';

        sliderState.forEach((state, sliderEl) => {
            if (state.mode === nextMode) {
                return;
            }

            const activeIndex = state.swiper.activeIndex;

            state.swiper.destroy(true, true);
            sliderState.set(sliderEl, createSwiper(sliderEl, state.wrap, activeIndex));
        });
    });
});
